<div class="NWMchart pl-5" [style.height.px]="height">
  @if (dataLoaded && chartData[0].data!.length > 0) {
    <canvas style="cursor: pointer;"
      baseChart
      [type]="chartType"
      [legend]="chartLegend"
      [datasets]="chartData"
      [labels]="chartLabels"
      [options]="chartSettings.options"
    (chartClick)="chartClicked($event)"></canvas>
  }
  @if (tooltip.visible) {
    <div class="NWMchart-tooltip">
      <table>
        @for (row of tooltip.rows; track row) {
          <tr class="{{row.class}}"><td class="tooltip-key">{{row.key}}</td><td class="tooltip-value">{{row.value}}</td></tr>
        }
      </table>
    </div>
  }
  @if (!dataLoaded) {
    <div class="insufficientdata">
      <div class="h6-text mx-3">Retrieving data ...</div>
    </div>
  }
  @if (dataLoaded && chartData[0].data!.length === 0) {
    <div class="insufficientdata">
      <div class="h6-text mx-3">Insufficient Data Available</div>
    </div>
  }
</div>
